import React, { PureComponent } from 'react'
import {
  Col,
  FormGroup,
  Input,
  Label,
  Card,
  CardHeader,
  CardBody,
  Button
} from 'reactstrap'
import axios from 'axios'
import Alert from '../../Widgets/Alert'
import withAlertTimeout from '../../../HOCs/withAlertTimeout'

class RemoveCategory extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isRemovingCategory: false,
      selectedCategory: null
    }
    this.removeCategory = this.removeCategory.bind(this)
    this.onCategorySelect = this.onCategorySelect.bind(this)
  }

  renderCategories() {
    return this.props.categories.map(cat => (
      <option key={cat.id} value={cat.id} onChange={this.onCategorySelect}>
        {cat.categoryName}
      </option>
    ))
  }

  removeCategory() {
    if (this.state.selectedCategory) {
      const token = sessionStorage.getItem('token')
      const headers = { Authorization: `Bearer ${token}` }
      this.setState({ isRemovingCategory: true })
      axios
        .delete(`/api/proxy/v2/categories/${this.state.selectedCategory}`, {
          headers
        })
        .then(({ data }) => {
          this.setState({ selectedCategory: null, isRemovingCategory: false })
          this.props.showSuccess()
          this.props.refresh()
        })
        .catch(err => {
          console.log(err)
          this.setState({ isRemovingCategory: false })
          this.props.showFailure()
        })
    }
  }

  onCategorySelect(e) {
    this.setState({ selectedCategory: e.target.selectedOptions[0].value })
  }

  render() {
    return (
      <Card>
        {<Alert active={this.props.success} message="Category Removed" />}
        {
          <Alert
            type="danger"
            active={this.props.failure}
            message="Something went wrong, please try again"
          />
        }
        <CardHeader>Remove a Category</CardHeader>
        <CardBody>
          <Col md="6" xs="12">
            <FormGroup>
              <Input
                type="select"
                name="select"
                id="select"
                onChange={this.onCategorySelect}
              >
                <option default value={null}>
                  Select a Category to Remove
                </option>
                {this.renderCategories()}
              </Input>
            </FormGroup>
            <Button
              style={{ float: 'right' }}
              type="submit"
              color="danger"
              onClick={this.removeCategory}
              disabled={!this.state.selectedCategory}
            >
              {this.state.isRemovingCategory && (
                <i
                  className="fa fa-circle-o-notch fa-spin"
                  style={{ marginRight: 5 }}
                />
              )}
              Remove
            </Button>
          </Col>
        </CardBody>
      </Card>
    )
  }
}

export default withAlertTimeout(RemoveCategory)



// WEBPACK FOOTER //
// ./src/views/Pages/Categories/RemoveCategory.js